<template>
  <v-dialog v-model="dialog_page_settings" width="640" content-class="card   settings-dialog ">
    <v-btn icon dark variant="text" class="dialog-close-btn" @click="$emit('close-dialog')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="h-100 settings-dialog-card">
      <v-row>
        <v-col cols="12" md="7">
          <p>Afmeldtermijn in uren</p>
          <k-spacing y="1"></k-spacing>

          <v-text-field hide-details density="compact" type="number" min="0" v-model="editsettings.cancellation_period" v-bind="props" variant="solo"></v-text-field>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="7">
          <p>Aantal credits per medewerker</p>
          <k-spacing y="1"></k-spacing>

          <v-text-field density="compact" hide-details type="number" v-model="editsettings.credits" v-bind="props" variant="solo"></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <p>Periode</p>
          <k-spacing y="1"></k-spacing>

          <v-select density="compact" hide-details v-model="editsettings.period" :items="periods" item-title="title" item-value="value" v-bind="props" variant="solo"></v-select>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="7">
          <p>Duratie inactiviteit mails</p>
          <k-spacing y="1"></k-spacing>

          <v-text-field hide-details density="compact" type="number" v-model="editsettings.inactive_amount" v-bind="props" variant="solo"></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <p>Periode inactiviteit mails</p>
          <k-spacing y="1"></k-spacing>

          <v-select hide-details density="compact" v-model="editsettings.inactive_period" :items="mail_periods" item-title="title" item-value="value" v-bind="props" variant="solo"></v-select>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>

      <v-row>
        <!-- <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Herinneringsmail 1</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.notice_mail_1" inset color="var(--primary)"></v-switch>
        </v-col>

        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Herinneringsmail 2</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.notice_mail_2" inset color="var(--primary)"></v-switch>
        </v-col> -->
        <v-col cols="12">
          <v-row v-for="reminder in reminders" :key="reminder.id">
            <v-col cols="12" md="10" class="d-flex">
              <p class="my-auto">Herinneringsmail {{ reminder.amount }} {{ convertReminderPeriodToString(reminder.period, reminder.amount) }} van te voren</p>
            </v-col>
            <v-col cols="12" md="2">
              <v-switch hide-details v-model="editsettings.reminders[reminder.id]" inset color="var(--primary)"></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="10" class="d-flex" @mouseenter="hover = true" @mouseleave="hover = false">
          <div class="d-flex flex-column" v-if="hover && editsettings.last_spots_mail">
            <div class="d-flex">
              <p class="my-auto">Laatste plekken e-mail</p>

              <span class="edit-btn ml-4 my-auto" @click="edit_last_spot_settings_dialog = true"> Edit </span>
            </div>
            <span class="periods-text mt-2">{{ formattedLastSpotsText() }}</span>
          </div>
          <p v-else class="my-auto">Laatste plekken e-mail</p>
        </v-col>
        <v-col cols="12" md="2" class="last-spot-row" @mouseenter="hover = true" @mouseleave="hover = false">
          <v-switch hide-details v-model="editsettings.last_spots_mail" inset color="var(--primary)"></v-switch>
        </v-col>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Nieuwe activiteit mail</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.new_activity_mail" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Wachtlijst</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.waitlist" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Telefoonnummer vragen bij aanmelden</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.ask_phone" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Publieke bedrijfslink</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.public_page" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Deelnemers tonen</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.show_participants" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>

      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Accountbeheeromgeving</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.account_management" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">E-mail verificatie</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.email_verification" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Collega's uitnodigen</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.invite_colleagues" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Domeinrestrictie</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.domain_restriction" inset color="var(--primary)"></v-switch>
        </v-col>
        <v-col v-if="editsettings.domain_restriction" cols="12" class="pt-0">
          <v-text-field
            density="compact"
            variant="solo"
            hide-details="auto"
            v-model="new_domain"
            placeholder="@bedrijfsnaam.nl"
            :error-messages="domain_error"
            @keyup.enter="addDomain()"
            @update:model-value="domain_error = ''"
          >
            <template v-slot:append-inner>
              <span class="edit-btn" @click.stop="addDomain()">Toevoegen</span>
            </template>
          </v-text-field>
          <v-chip-group v-if="editsettings.allowed_domains && editsettings.allowed_domains.length">
            <v-chip v-for="(item, index) in editsettings.allowed_domains" :key="item">
              @{{ item }}
              <span class="ml-1 delete-period-btn" @click="editsettings.allowed_domains.splice(index, 1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M1.99992 9.1665L0.833252 7.99984L3.83325 4.99984L0.833252 2.02067L1.99992 0.854004L4.99992 3.854L7.97908 0.854004L9.14575 2.02067L6.14575 4.99984L9.14575 7.99984L7.97908 9.1665L4.99992 6.1665L1.99992 9.1665Z" fill="#4E4E4E" />
                </svg>
              </span>
            </v-chip>
          </v-chip-group>
          <!-- Aan zonder domeinen is bewust géén slot op de pagina: zonder deze
               regel zou één klik op de switch een live openbare pagina sluiten. -->
          <p v-else class="periods-text mt-3">Voeg minimaal één domein toe. Zolang de lijst leeg is, verandert de restrictie niets.</p>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="12" class="">
          <p class="">Beperk weergave tot geselecteerde periode</p>
          <k-spacing y="1"></k-spacing>

          <v-select hide-details density="compact" v-model="editsettings.display_period" :items="display_periods" item-title="title" item-value="value" variant="solo"></v-select>
        </v-col>
        <v-col v-if="editsettings.display_period == 'custom_days'" cols="12" md="12" class="">
          <p class="">Aantal dagen</p>
          <k-spacing y="1"></k-spacing>
          <v-text-field hide-details density="compact" type="number" v-model="editsettings.display_custom_days" variant="solo"></v-text-field>
        </v-col>
        <v-col v-if="editsettings.display_period == 'custom_period'" cols="12" md="6">
          <p>Start periode</p>
          <k-spacing y="1"></k-spacing>
          <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition">
            <template v-slot:activator="{ props }">
              <v-text-field v-bind="props" v-model="formattedStartDate" readonly hide-details density="compact" variant="solo">
                <template v-slot:prepend-inner>
                  <v-icon size="24" @click.stop="menuEnd != menuEnd"
                    ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 22.0002C4.45 22.0002 3.97917 21.8044 3.5875 21.4127C3.19583 21.0211 3 20.5502 3 20.0002V6.00024C3 5.45024 3.19583 4.97941 3.5875 4.58774C3.97917 4.19608 4.45 4.00024 5 4.00024H6V2.00024H8V4.00024H16V2.00024H18V4.00024H19C19.55 4.00024 20.0208 4.19608 20.4125 4.58774C20.8042 4.97941 21 5.45024 21 6.00024V20.0002C21 20.5502 20.8042 21.0211 20.4125 21.4127C20.0208 21.8044 19.55 22.0002 19 22.0002H5ZM5 20.0002H19V10.0002H5V20.0002ZM5 8.00024H19V6.00024H5V8.00024ZM12 14.0002C11.7167 14.0002 11.4792 13.9044 11.2875 13.7127C11.0958 13.5211 11 13.2836 11 13.0002C11 12.7169 11.0958 12.4794 11.2875 12.2877C11.4792 12.0961 11.7167 12.0002 12 12.0002C12.2833 12.0002 12.5208 12.0961 12.7125 12.2877C12.9042 12.4794 13 12.7169 13 13.0002C13 13.2836 12.9042 13.5211 12.7125 13.7127C12.5208 13.9044 12.2833 14.0002 12 14.0002ZM8 14.0002C7.71667 14.0002 7.47917 13.9044 7.2875 13.7127C7.09583 13.5211 7 13.2836 7 13.0002C7 12.7169 7.09583 12.4794 7.2875 12.2877C7.47917 12.0961 7.71667 12.0002 8 12.0002C8.28333 12.0002 8.52083 12.0961 8.7125 12.2877C8.90417 12.4794 9 12.7169 9 13.0002C9 13.2836 8.90417 13.5211 8.7125 13.7127C8.52083 13.9044 8.28333 14.0002 8 14.0002ZM16 14.0002C15.7167 14.0002 15.4792 13.9044 15.2875 13.7127C15.0958 13.5211 15 13.2836 15 13.0002C15 12.7169 15.0958 12.4794 15.2875 12.2877C15.4792 12.0961 15.7167 12.0002 16 12.0002C16.2833 12.0002 16.5208 12.0961 16.7125 12.2877C16.9042 12.4794 17 12.7169 17 13.0002C17 13.2836 16.9042 13.5211 16.7125 13.7127C16.5208 13.9044 16.2833 14.0002 16 14.0002ZM12 18.0002C11.7167 18.0002 11.4792 17.9044 11.2875 17.7127C11.0958 17.5211 11 17.2836 11 17.0002C11 16.7169 11.0958 16.4794 11.2875 16.2877C11.4792 16.0961 11.7167 16.0002 12 16.0002C12.2833 16.0002 12.5208 16.0961 12.7125 16.2877C12.9042 16.4794 13 16.7169 13 17.0002C13 17.2836 12.9042 17.5211 12.7125 17.7127C12.5208 17.9044 12.2833 18.0002 12 18.0002ZM8 18.0002C7.71667 18.0002 7.47917 17.9044 7.2875 17.7127C7.09583 17.5211 7 17.2836 7 17.0002C7 16.7169 7.09583 16.4794 7.2875 16.2877C7.47917 16.0961 7.71667 16.0002 8 16.0002C8.28333 16.0002 8.52083 16.0961 8.7125 16.2877C8.90417 16.4794 9 16.7169 9 17.0002C9 17.2836 8.90417 17.5211 8.7125 17.7127C8.52083 17.9044 8.28333 18.0002 8 18.0002ZM16 18.0002C15.7167 18.0002 15.4792 17.9044 15.2875 17.7127C15.0958 17.5211 15 17.2836 15 17.0002C15 16.7169 15.0958 16.4794 15.2875 16.2877C15.4792 16.0961 15.7167 16.0002 16 16.0002C16.2833 16.0002 16.5208 16.0961 16.7125 16.2877C16.9042 16.4794 17 16.7169 17 17.0002C17 17.2836 16.9042 17.5211 16.7125 17.7127C16.5208 17.9044 16.2833 18.0002 16 18.0002Z"
                        fill="#858585" /></svg
                  ></v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker hide-header locale="nl" color="var(--primary)" v-model="start" @update:model-value="menuEnd = false"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col v-if="editsettings.display_period == 'custom_period'" cols="12" md="6">
          <p>Einde periode</p>
          <k-spacing y="1"></k-spacing>
          <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition">
            <template v-slot:activator="{ props }">
              <v-text-field v-bind="props" v-model="formattedEndDate" readonly hide-details density="compact" variant="solo">
                <template v-slot:prepend-inner>
                  <v-icon size="24" @click.stop="menuEnd != menuEnd"
                    ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 22.0002C4.45 22.0002 3.97917 21.8044 3.5875 21.4127C3.19583 21.0211 3 20.5502 3 20.0002V6.00024C3 5.45024 3.19583 4.97941 3.5875 4.58774C3.97917 4.19608 4.45 4.00024 5 4.00024H6V2.00024H8V4.00024H16V2.00024H18V4.00024H19C19.55 4.00024 20.0208 4.19608 20.4125 4.58774C20.8042 4.97941 21 5.45024 21 6.00024V20.0002C21 20.5502 20.8042 21.0211 20.4125 21.4127C20.0208 21.8044 19.55 22.0002 19 22.0002H5ZM5 20.0002H19V10.0002H5V20.0002ZM5 8.00024H19V6.00024H5V8.00024ZM12 14.0002C11.7167 14.0002 11.4792 13.9044 11.2875 13.7127C11.0958 13.5211 11 13.2836 11 13.0002C11 12.7169 11.0958 12.4794 11.2875 12.2877C11.4792 12.0961 11.7167 12.0002 12 12.0002C12.2833 12.0002 12.5208 12.0961 12.7125 12.2877C12.9042 12.4794 13 12.7169 13 13.0002C13 13.2836 12.9042 13.5211 12.7125 13.7127C12.5208 13.9044 12.2833 14.0002 12 14.0002ZM8 14.0002C7.71667 14.0002 7.47917 13.9044 7.2875 13.7127C7.09583 13.5211 7 13.2836 7 13.0002C7 12.7169 7.09583 12.4794 7.2875 12.2877C7.47917 12.0961 7.71667 12.0002 8 12.0002C8.28333 12.0002 8.52083 12.0961 8.7125 12.2877C8.90417 12.4794 9 12.7169 9 13.0002C9 13.2836 8.90417 13.5211 8.7125 13.7127C8.52083 13.9044 8.28333 14.0002 8 14.0002ZM16 14.0002C15.7167 14.0002 15.4792 13.9044 15.2875 13.7127C15.0958 13.5211 15 13.2836 15 13.0002C15 12.7169 15.0958 12.4794 15.2875 12.2877C15.4792 12.0961 15.7167 12.0002 16 12.0002C16.2833 12.0002 16.5208 12.0961 16.7125 12.2877C16.9042 12.4794 17 12.7169 17 13.0002C17 13.2836 16.9042 13.5211 16.7125 13.7127C16.5208 13.9044 16.2833 14.0002 16 14.0002ZM12 18.0002C11.7167 18.0002 11.4792 17.9044 11.2875 17.7127C11.0958 17.5211 11 17.2836 11 17.0002C11 16.7169 11.0958 16.4794 11.2875 16.2877C11.4792 16.0961 11.7167 16.0002 12 16.0002C12.2833 16.0002 12.5208 16.0961 12.7125 16.2877C12.9042 16.4794 13 16.7169 13 17.0002C13 17.2836 12.9042 17.5211 12.7125 17.7127C12.5208 17.9044 12.2833 18.0002 12 18.0002ZM8 18.0002C7.71667 18.0002 7.47917 17.9044 7.2875 17.7127C7.09583 17.5211 7 17.2836 7 17.0002C7 16.7169 7.09583 16.4794 7.2875 16.2877C7.47917 16.0961 7.71667 16.0002 8 16.0002C8.28333 16.0002 8.52083 16.0961 8.7125 16.2877C8.90417 16.4794 9 16.7169 9 17.0002C9 17.2836 8.90417 17.5211 8.7125 17.7127C8.52083 17.9044 8.28333 18.0002 8 18.0002ZM16 18.0002C15.7167 18.0002 15.4792 17.9044 15.2875 17.7127C15.0958 17.5211 15 17.2836 15 17.0002C15 16.7169 15.0958 16.4794 15.2875 16.2877C15.4792 16.0961 15.7167 16.0002 16 16.0002C16.2833 16.0002 16.5208 16.0961 16.7125 16.2877C16.9042 16.4794 17 16.7169 17 17.0002C17 17.2836 16.9042 17.5211 16.7125 17.7127C16.5208 17.9044 16.2833 18.0002 16 18.0002Z"
                        fill="#858585" /></svg
                  ></v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker hide-header locale="nl" color="var(--primary)" v-model="end" @update:model-value="menuEnd = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Google & Microsoft agenda inschakelen</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.calendar_integration" inset color="var(--primary)"></v-switch>
        </v-col>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">iCal-bijlage in e-mails</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.ical_link" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
      <k-spacing y="6"></k-spacing>

      <v-divider></v-divider>
      <k-spacing y="6"></k-spacing>
      <!-- Until the promotiemodule has an activation of its own (ADR-0104). -->
      <v-row>
        <v-col cols="12" md="10" class="d-flex">
          <p class="my-auto">Promotiemodule (knop "Bekijk promotiemateriaal" in de mails na het intakeformulier)</p>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch hide-details v-model="editsettings.promotion_module" inset color="var(--primary)"></v-switch>
        </v-col>
      </v-row>
    </div>
    <k-spacing y="6"></k-spacing>
    <v-row cols="12" md="5">
      <v-btn @click="$emit('update-settings', editsettings, true)" class="btn text-white" color="var(--tertiary)"> Opslaan </v-btn>
    </v-row>
    <v-dialog v-model="edit_last_spot_settings_dialog" width="640" content-class="card   settings-dialog ">
      <h3>Laatste plekken e-mail</h3>
      <k-spacing y="10"></k-spacing>
      <p class="mb-1">Periode</p>
      <v-select hide-details density="compact" multiple v-model="editsettings.last_spot_periods" :items="last_spot_periods" item-title="title" item-value="value" variant="solo"></v-select>
      <k-spacing y="6"></k-spacing>
      <p class="mb-1">Aangepaste periode</p>
      <div class="d-flex">
        <v-text-field variant="solo" density="compact" min="0" v-model="new_period" hide-details type="number">
          <template v-slot:append-inner> Dagen </template>
        </v-text-field>
        <div class="add-period-btn ml-4" @click="addPeriod()">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <mask id="mask0_7141_47260" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
              <rect width="28" height="28" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_7141_47260)">
              <path d="M12.8335 15.1668H5.8335V12.8335H12.8335V5.8335H15.1668V12.8335H22.1668V15.1668H15.1668V22.1668H12.8335V15.1668Z" fill="#00BCEE" />
            </g>
          </svg>
        </div>
      </div>
      <k-spacing y="6"></k-spacing>
      <p class="mb-1">Geselcteerde periodes</p>
      <v-chip-group v-if="editsettings.last_spot_periods">
        <v-chip v-for="(item, index) in sortPeriods(editsettings.last_spot_periods)" :key="index">
          {{ formatLabel(item) }}
          <span class="ml-1 delete-period-btn" @click="editsettings.last_spot_periods.splice(index, 1)">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M1.99992 9.1665L0.833252 7.99984L3.83325 4.99984L0.833252 2.02067L1.99992 0.854004L4.99992 3.854L7.97908 0.854004L9.14575 2.02067L6.14575 4.99984L9.14575 7.99984L7.97908 9.1665L4.99992 6.1665L1.99992 9.1665Z" fill="#4E4E4E" />
            </svg>
          </span>
        </v-chip>
      </v-chip-group>
      <k-spacing y="10"></k-spacing>
      <v-row cols="12" md="5">
        <v-btn @click="updateLastSpotSettings()" class="btn text-white" color="var(--tertiary)"> Opslaan </v-btn>
      </v-row>
    </v-dialog>
  </v-dialog>
</template>

<script>
import SettingsService from "@/services/SettingsService";
export default {
  props: {
    settings: Object
  },
  mounted() {
    this.getReminders();

    this.editsettings = this.settings != undefined ? this.getOwnPropertyDescriptors(this.settings) : this.editsettings;
    if (!this.editsettings.last_spot_periods) {
      this.editsettings.last_spot_periods = [];
    }
    if (!Array.isArray(this.editsettings.allowed_domains)) {
      this.editsettings.allowed_domains = [];
    }
    // De backend leest afwezig/null als AAN; zorg dat de switch dat spiegelt en
    // opslaan de wachtlijst niet stilletjes uitzet.
    if (this.editsettings.waitlist === undefined || this.editsettings.waitlist === null) {
      this.editsettings.waitlist = true;
    }
    // Idem voor de deelnemersweergave (ADR-0059): afwezig betekent aan, dus de
    // switch moet dat spiegelen voordat opslaan hem als `false` wegschrijft.
    if (
      this.editsettings.show_participants === undefined ||
      this.editsettings.show_participants === null
    ) {
      this.editsettings.show_participants = true;
    }
    // Idem voor het telefoonnummer (ADR-0091).
    if (this.editsettings.ask_phone === undefined || this.editsettings.ask_phone === null) {
      this.editsettings.ask_phone = true;
    }
  },
  watch: {
    start() {
      this.editsettings.display_start = this.start;
    },
    end() {
      this.editsettings.display_end = this.end;
    }
  },
  data() {
    return {
      dialog_page_settings: false,
      copysnackbar: "",
      end: null,
      hover: false,
      new_period: 0,
      start: null,
      menuStart: false,
      menuEnd: false,
      edit_last_spot_settings_dialog: false,
      display_periods: [
        { title: "Alles weergeven", value: "all" },
        { title: "1 week", value: "1_week" },
        { title: "2 weken", value: "two_weeks" },
        { title: "1 maand", value: "one_month" },
        { title: "2 maanden", value: "two_months" },
        { title: "3 maanden", value: "three_months" },
        { title: "6 maanden", value: "six_months" },
        { title: "12 maanden (1 jaar)", value: "year" },
        { title: "Huidig kalenderjaar", value: "current_year" },
        { title: "18 maanden (1,5 jaar)", value: "eighteen_months" },
        { title: "24 maanden (2 jaar)", value: "two_years" },
        { title: "Aangepaste aantal dagen", value: "custom_days" },
        { title: "Aangepaste periode", value: "custom_period" }
      ],
      editsettings: {},
      new_domain: "",
      domain_error: "",
      periods: [
        {
          title: "Dag",
          value: "day"
        },
        {
          title: "Week",
          value: "week"
        },
        {
          title: "Maand",
          value: "month"
        },
        {
          title: "Jaar",
          value: "year"
        }
      ],
      last_spot_periods: [
        {
          title: "Zelfde dag (Ochtend)",
          value: 0
        },
        {
          title: "1 dag vooraf",
          value: 1
        },
        {
          title: "2 dagen vooraf",
          value: 2
        },

        {
          title: "1 week vooraf",
          value: 5
        },
        {
          title: "2 weken vooraf",
          value: 10
        },
        {
          title: "4 weken vooraf",
          value: 20
        }
      ],
      mail_periods: [
        {
          title: "Dag",
          value: "day"
        },
        {
          title: "Week",
          value: "week"
        },
        {
          title: "Maand",
          value: "month"
        }
      ],
      copysnackbar_status: "",

      reminders: []
    };
  },
  computed: {
    formattedStartDate() {
      return this.editsettings.display_start ? new Date(this.editsettings.display_start).toLocaleDateString() : "";
    },
    formattedEndDate() {
      return this.editsettings.display_end ? new Date(this.editsettings.display_end).toLocaleDateString() : "";
    }
  },
  methods: {
    formattedLastSpotsText() {
      const periods = this.sortPeriods(this.editsettings?.last_spot_periods) || [];
      if (!Array.isArray(periods) || periods.length === 0) return "";

      return periods.map((p) => this.formatLabel(p?.value ?? p)).join(", ");
    },
    sortPeriods(periods) {
      return [...periods].map(Number).sort((a, b) => a - b);
    },

    formatLabel(period) {
      switch (period) {
        case 0:
          return "Zelfde dag (Ochtend)";
        case 1:
          return "1 dag vooraf";
        case 2:
          return "2 dagen vooraf";

        case 5:
          return "1 week vooraf";
        case 10:
          return "2 weken vooraf";
        case 20:
          return "4 weken vooraf";
        default: {
          if (period >= 5 && period % 5 === 0) {
            const w = period / 5;
            return `${w} ${w === 1 ? "week" : "weken"} vooraf`;
          }
          return `${period} ${period == 1 ? "werkdag" : "werkdagen"} vooraf`;
        }
      }
    },

    addPeriod() {
      this.editsettings.last_spot_periods.push(this.new_period);
      this.new_period = 0;
    },
    updateLastSpotSettings() {
      this.edit_last_spot_settings_dialog = false;
      this.$emit("update-settings", this.editsettings, false);
    },
    updateStartDate(date) {
      this.editsettings.display_start = new Date(date).getTime(); // Converts back to epoch timestamp
      this.menuStart = false; // Close the menu
    },
    getOwnPropertyDescriptors(model) {
      var obj = JSON.parse(JSON.stringify(model));

      Object.keys(obj).reduce(function (obj, key) {
        if (obj["_" + key] === obj[key]) {
          delete obj["_" + key];
        }
        return obj;
      }, obj);
      return obj;
    },
    updateLink(newLink) {
      // Emit an input event to update the prop value
      this.$emit("update:link", newLink);
    },

    async getReminders() {
      await SettingsService.getReminders()
        .then((res) => {
          if (this.editsettings.reminders === undefined) {
            this.editsettings.reminders = {};
            res.data.success.forEach((r) => {
              this.editsettings.reminders[r.id] = true;
            });
          }

          console.log("editsettings", this.editsettings);

          this.reminders = res.data.success;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * Mirrors EmailDomain::normalize on the API — same accepted forms, same
     * rejections. The server normalises again on save; this is so the chip shows
     * what will actually be stored and a typo is caught before Opslaan.
     */
    normalizeDomain(raw) {
      if (typeof raw !== "string") return null;

      let value = raw.trim().toLowerCase();
      const at = value.lastIndexOf("@");
      if (at !== -1) value = value.slice(at + 1);
      value = value.replace(/\.+$/, "");
      if (value.startsWith("www.")) value = value.slice(4);

      const host = /^(?=.{1,253}$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/;
      return host.test(value) ? value : null;
    },

    addDomain() {
      const host = this.normalizeDomain(this.new_domain);
      if (!host) {
        this.domain_error = "Vul een geldig e-maildomein in, bijvoorbeeld @bedrijfsnaam.nl.";
        return;
      }
      if (!Array.isArray(this.editsettings.allowed_domains)) {
        this.editsettings.allowed_domains = [];
      }
      if (this.editsettings.allowed_domains.includes(host)) {
        this.domain_error = "Dit domein staat al in de lijst.";
        return;
      }

      this.editsettings.allowed_domains.push(host);
      this.new_domain = "";
      this.domain_error = "";
    },

    convertReminderPeriodToString(period, amount) {
      const plural = amount > 1;
      switch (period) {
        // "uur" is in beide vormen gelijk; 'month' bestaat niet als periode.
        case "hours":
          return "uur";
        case "day":
          return plural ? "dagen" : "dag";
        case "week":
          return plural ? "weken" : "week";
        default:
          return period;
      }
    }
  }
};
</script>
